import script from "./config.vue?vue&type=script&setup=true&lang=js"
export * from "./config.vue?vue&type=script&setup=true&lang=js"

import "./config.vue?vue&type=style&index=0&id=34333cf7&lang=scss"

const __exports__ = script;

export default __exports__